import { secondAxios } from "../../../../../../api/axios";

export const getProject = async ({ plantId }) => {
  try {
    const res = await secondAxios.get("/plant/" + plantId);
    // console.log("doc-transmittal project:", res);

    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getAllDocTransmittalsProject = async ({ plantId }) => {
  try {
    const res = await secondAxios.get("/doc-transmittal/project/" + plantId);
    console.log("doc-transmittal project:", res);

    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const addNewDocTransmittal = async (formData) => {
  const { data } = await secondAxios.post("/doc-transmittal", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const addNewDocTransmittalRegister = async (item) => {
  const { data } = await secondAxios.post(
    "/doc-transmittal/new-register",
    item
  );
  return data;
};
export const getCompanyVendors = async () => {
  const getCompanyVendorsApi = "/vendor";
  const { data } = await secondAxios.get(getCompanyVendorsApi);
  //   console.log(data);
  return data;
};

export const getCompanyCustomers = async () => {
  const getCompanyCustomersApi = "/customer";
  const { data } = await secondAxios.get(getCompanyCustomersApi);
  console.log(data);
  return data;
};
